import { getPivot as r } from "./index12.js";
import { Vector3 as e } from "three";
const i = new e();
function m(t, o) {
  return r(t, o, i).toArray();
}
export {
  m as getPivotRaw
};
//# sourceMappingURL=index11.js.map
